/* OCUDERM — la capa de movimiento.
 *
 * Es lo que hacía que el tema, con la tipografía y los colores ya clavados,
 * siguiera sin parecer el mismo sitio: todo lo estático estaba migrado y nada
 * de lo que se mueve. Aquí van las cuatro piezas, portadas del sitio:
 *
 *   1. REVEAL      el contenido entra con fundido y desplazamiento al llegar
 *   2. PARALLAX    los guijarros se mueven con el scroll a distinta profundidad
 *   3. KEN BURNS   las fotos de hero hacen un zoom lento y continuo
 *   4. CORTINA     panel espresso con el ojo que tapa el cambio de página
 *
 * TODO RESPETA `prefers-reduced-motion`. No es un detalle de cortesía: esto
 * es la web de una oficina médica, y entre sus pacientes hay gente a la que el
 * movimiento le produce mareo. Con la preferencia puesta, el contenido aparece
 * de golpe y la cortina no se dibuja — pero nada deja de funcionar.
 *
 * POR QUÉ NO USA IntersectionObserver
 *
 * El original hace una pasada por scroll y REPARA lo que se quedó escondido.
 * Suena redundante hasta que pasa: una animación cancelada a medias, una
 * pestaña que vuelve de segundo plano, o el editor de temas recargando una
 * sección, dejan elementos en `opacity: 0` para siempre. Un observer no se
 * entera; una pasada que vuelve a mirar, sí. Se mantiene ese criterio.
 */
(function () {
  'use strict';
  if (window.__ocuMotion) return;
  window.__ocuMotion = true;

  var script = document.currentScript;
  var MARCA = (script && script.dataset.mark) || '';
  var canWA = typeof Element !== 'undefined' && !!Element.prototype.animate;
  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var S = function (sel, raiz) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(sel));
  };

  /* ── 1. Reveal ──────────────────────────────────────────────────────────
     Tres modos, los mismos del sitio:
       [data-reveal]          el bloque entero sube y aparece
       [data-reveal="mask"]   se descubre de abajo arriba, y la foto de dentro
                              arranca al 1.2 y se asienta
       [data-stagger]         los hijos entran uno detrás de otro, 120ms */

  var EASE = 'cubic-bezier(.16,.68,.24,1)';

  function hijos(el) {
    return Array.prototype.slice.call(el.children);
  }

  function mostrar(el) {
    if (el.hasAttribute('data-stagger')) {
      hijos(el).forEach(function (k) {
        k.style.opacity = '1';
        k.style.transform = 'none';
        k.style.willChange = 'auto';
      });
    } else {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.clipPath = 'none';
      el.style.willChange = 'auto';
    }
  }

  function preparar(el) {
    if (el.hasAttribute('data-stagger')) {
      hijos(el).forEach(function (k) {
        k.style.opacity = '0';
        k.style.transform = 'translateY(30px)';
        k.style.willChange = 'opacity, transform';
      });
    } else if (el.getAttribute('data-reveal') === 'mask') {
      el.style.clipPath = 'inset(100% 0 0 0)';
      el.style.willChange = 'clip-path';
    } else {
      el.style.opacity = '0';
      el.style.transform = 'translateY(34px)';
      el.style.willChange = 'opacity, transform';
    }
  }

  function escondido(el) {
    var cs = getComputedStyle(el);
    if (parseFloat(cs.opacity) < 0.9) return true;
    if ((cs.clipPath || '').indexOf('100%') > -1) return true;
    if (el.hasAttribute('data-stagger')) {
      var ks = hijos(el);
      for (var i = 0; i < ks.length; i++) {
        if (parseFloat(getComputedStyle(ks[i]).opacity) < 0.9) return true;
      }
    }
    return false;
  }

  function reparar(el) {
    try {
      if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
      hijos(el).forEach(function (k) {
        if (k.getAnimations) k.getAnimations().forEach(function (a) { a.cancel(); });
      });
    } catch (e) {}
    mostrar(el);
  }

  function reproducir(el) {
    /* La base visible se escribe ANTES de animar. `fill: 'backwards'` solo
       cubre el tramo previo al inicio; si el elemento no quedara visible por
       estilo, al terminar la animación volvería a desaparecer. */
    mostrar(el);
    /* NO SE MIRA SI LA PESTAÑA ESTÁ VISIBLE

       Tenía aquí un `document.visibilityState !== 'visible'` que me pareció un
       ahorro —no animar lo que nadie ve—, y lo que hacía era matar el efecto
       para siempre: una pestaña abierta en segundo plano marcaba todo como
       mostrado sin animar, y al volver a ella la página ya estaba entera y
       quieta. El sitio no mira la visibilidad, y el navegador ya pausa las
       animaciones de las pestañas de fondo por su cuenta. */
    if (!canWA || reduce) return;

    if (el.hasAttribute('data-stagger')) {
      hijos(el).forEach(function (k, i) {
        k.animate(
          [{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'none' }],
          { duration: 1100, delay: i * 120, easing: EASE, fill: 'backwards' }
        );
      });
    } else if (el.getAttribute('data-reveal') === 'mask') {
      el.animate(
        [{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0% 0 0 0)' }],
        { duration: 1150, easing: EASE, fill: 'backwards' }
      );
      var img = el.querySelector('img');
      if (img) {
        img.animate([{ transform: 'scale(1.2)' }, { transform: 'scale(1)' }], {
          duration: 1500,
          easing: EASE,
          fill: 'backwards',
        });
      }
    } else {
      el.animate(
        [{ opacity: 0, transform: 'translateY(34px)' }, { opacity: 1, transform: 'none' }],
        { duration: 1300, easing: EASE, fill: 'backwards' }
      );
    }
  }

  var repaso = null;

  function pasada() {
    var els = S('[data-reveal],[data-stagger]');
    if (!els.length) return;
    var vh = window.innerHeight || 800;
    var pendientes = 0;
    var rotos = 0;

    els.forEach(function (el) {
      if (el.getAttribute('data-shown') === '1') {
        if (escondido(el)) {
          reparar(el);
          rotos++;
        }
        return;
      }
      var r = el.getBoundingClientRect();
      // Ya pasó de largo: se enseña sin animar, que si no aparece al volver.
      if (r.bottom < 0) {
        el.setAttribute('data-shown', '1');
        mostrar(el);
        return;
      }
      if (r.top < vh * 0.92) {
        el.setAttribute('data-shown', '1');
        reproducir(el);
        return;
      }
      preparar(el);
      pendientes++;
    });

    if (!pendientes && !rotos && repaso) {
      clearInterval(repaso);
      repaso = null;
    }
  }

  /* ── 2. Parallax ────────────────────────────────────────────────────────
     Los guijarros se desplazan según lo lejos que estén del centro de la
     ventana, multiplicado por su `data-depth`. Los `[data-drift]` —las fotos
     del collage— llevan tope de 46px: sin él, en una pantalla alta se salen
     de su hueco. */

  function parallax() {
    var vc = (window.innerHeight || 800) / 2;
    var ancho = window.innerWidth > 900;

    S('[data-drift]').forEach(function (p) {
      if (!ancho || reduce) {
        p.style.transform = 'none';
        return;
      }
      var d = parseFloat(p.getAttribute('data-depth')) || 0.1;
      var r = p.getBoundingClientRect();
      if (r.bottom < -200 || r.top > (window.innerHeight || 800) + 200) return;
      var crudo = (r.top + r.height / 2 - vc) * -d;
      var off = Math.max(-46, Math.min(46, crudo));
      p.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });

    S('[data-pebble]').forEach(function (p) {
      if (reduce) {
        p.style.transform = 'none';
        return;
      }
      var d = parseFloat(p.getAttribute('data-depth')) || 0.15;
      var r = p.getBoundingClientRect();
      var off = (r.top + r.height / 2 - vc) * -d;
      p.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
  }

  /* ── 3. Ken Burns ───────────────────────────────────────────────────────
     Un zoom lento y en una sola dirección, reiniciado cada vez. Lineal y de
     ida: una animación alterna se queda parada en un extremo justo cuando
     alguien está mirando. */

  function kenBurns(el) {
    if (!el || !canWA || reduce) return;
    if (document.visibilityState !== 'visible') return;
    try {
      if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
    } catch (e) {}
    el.style.transformOrigin = 'center';
    el.animate([{ transform: 'scale(1.04)' }, { transform: 'scale(1.13)' }], {
      duration: 15000,
      easing: 'linear',
      fill: 'forwards',
    });
  }

  function arrancarKenBurns() {
    S('[data-kenburns]').forEach(kenBurns);
  }

  /* ── 3b. Los tres modos de la barra ─────────────────────────────────────
     La cabecera del sitio no tiene dos estados sino TRES, y el que toca lo
     decide la sección que tiene detrás:

       glass  sobre el hero — transparente con el degradado, tinta crema,
              alta (14px de aire, logo a 52)
       dark   desplazada sobre una sección oscura — espresso translúcido con
              desenfoque, tinta crema, compacta (8px, logo a 40)
       cream  desplazada sobre una sección clara — crema translúcido, logo
              NEGRO y enlaces en ocre, compacta

     Lo de mirar qué hay detrás es lo que hace que la barra nunca quede crema
     sobre crema ni espresso sobre espresso. Las secciones oscuras se marcan
     con `data-dark` en el Liquid. */

  var barra = document.querySelector('.header-wrapper');
  var modoActual = null;

  function modoBarra() {
    if (!barra) return;
    var alto = barra.getBoundingClientRect().height || 90;
    var hero = document.querySelector('.ocu-hero');

    /* El umbral del sitio son 30px, no 8: con 8 la barra cambiaba a crema
       cuando el hero aún asomaba un dedo por debajo, y se veía el cambio justo
       antes de que tocara. */
    var modo;
    if (hero && hero.getBoundingClientRect().bottom > alto + 30) {
      modo = 'glass';
    } else {
      /* Qué sección oscura cruza el borde inferior de la barra. Se comparan
         rectángulos en vez de preguntar `elementsFromPoint`: en ese punto
         puede haber un hijo con fondo propio —una tarjeta, una foto— y
         entonces la respuesta es ese hijo y no la sección, así que la barra se
         quedaba en crema sobre una sección espresso.

         Las dos condiciones son las del sitio: la sección ya empezó (su borde
         superior está por encima del de la barra menos 6) y todavía cubre al
         menos la mitad de la altura de la barra. */
      var oscuras = document.querySelectorAll('[data-dark]');
      var oscura = false;
      for (var i = 0; i < oscuras.length; i++) {
        var r = oscuras[i].getBoundingClientRect();
        if (r.top < alto - 6 && r.bottom > alto * 0.5) { oscura = true; break; }
      }
      modo = oscura ? 'dark' : 'cream';
    }

    if (modo === modoActual) return;
    modoActual = modo;
    barra.classList.remove('ocu-nav--glass', 'ocu-nav--dark', 'ocu-nav--cream');
    barra.classList.add('ocu-nav--' + modo);
  }

  /* ── 4. La cortina entre páginas ────────────────────────────────────────
     Panel espresso que sube tapando la página con el ojo de la marca en medio,
     y que en la página nueva baja y se retira. El relevo se pasa por
     `sessionStorage`: la página que se va deja la bandera, la que llega la lee
     y se destapa. */

  var BANDERA = 'ocu:navigating';
  var EASE_C = 'cubic-bezier(.72,.02,.28,1)';

  function panel() {
    var el = document.createElement('div');
    el.setAttribute('data-ocu-curtain', '');
    el.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:9998',
      'pointer-events:none',
      'background:#2e210e',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'will-change:clip-path,opacity',
    ].join(';');
    var marca = null;
    if (MARCA) {
      marca = document.createElement('img');
      marca.src = MARCA;
      marca.alt = '';
      marca.setAttribute('aria-hidden', 'true');
      marca.style.cssText =
        'height:clamp(52px,6.5vw,86px);width:auto;opacity:0;filter:brightness(0) invert(1);will-change:opacity,transform;';
      el.appendChild(marca);
    }
    document.body.appendChild(el);
    return { el: el, marca: marca };
  }

  function subir(hecho) {
    var p = panel();
    p.el.style.clipPath = 'inset(100% 0 0 0)';
    if (!canWA || reduce) {
      hecho();
      return;
    }
    p.el.animate([{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0% 0 0 0)' }], {
      duration: 460,
      easing: EASE_C,
      fill: 'forwards',
    });
    if (p.marca) {
      p.marca.animate(
        [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
        { duration: 300, delay: 200, easing: 'cubic-bezier(.22,.75,.2,1)', fill: 'forwards' }
      );
    }
    setTimeout(hecho, 520);
  }

  function bajar() {
    var p = panel();
    p.el.style.clipPath = 'inset(0% 0 0 0)';
    if (p.marca) p.marca.style.opacity = '1';

    /* El relevo con la tapa de `theme.liquid`.

       Esa tapa es un pseudoelemento del `<html>` que ya está puesta desde el
       primer fotograma, con el mismo espresso y la misma marca. Este panel se
       cuelga del `<body>`, así que se pinta por encima: al quitar la tapa
       justo DESPUÉS de colgarlo, no hay ni un fotograma sin cubrir.

       Quitarla antes, o no quitarla, serían las dos formas de que se notara:
       antes se vería la página asomar, y sin quitarla la pasada de salida
       descubriría el panel pero no la tapa, y la pantalla se quedaría marrón
       hasta que saltara la red de los tres segundos. */
    document.documentElement.removeAttribute('data-ocu-entrando');

    var quitar = function () {
      if (p.el.parentNode) p.el.parentNode.removeChild(p.el);
    };
    if (!canWA || reduce) {
      quitar();
      return;
    }
    if (p.marca) {
      p.marca.animate(
        [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-10px)' }],
        { duration: 260, easing: 'ease-in', fill: 'forwards' }
      );
    }
    var a = p.el.animate([{ clipPath: 'inset(0% 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], {
      duration: 620,
      delay: 120,
      easing: EASE_C,
      fill: 'forwards',
    });
    a.onfinish = quitar;
    setTimeout(quitar, 900);
  }

  /* Qué enlaces llevan cortina. En Shopify esto es más delicado que en el
     sitio estático: hay enlaces que no navegan —abren el cajón, cambian una
     variante, envían un formulario— y taparlos con una cortina que luego no
     se levanta deja la tienda en negro. De ahí la lista de exclusiones. */
  function interno(a) {
    if (!a) return null;
    if (a.target && a.target !== '_self') return null;
    if (a.hasAttribute('download')) return null;
    if (a.hasAttribute('data-no-curtain')) return null;
    // Nada que viva dentro del carrito, del buscador o de un desplegable.
    if (a.closest('cart-drawer, .cart-notification, .header__search, predictive-search, .quantity, .shopify-payment-button')) {
      return null;
    }
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return null;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return null;

    var abs;
    try {
      abs = new URL(href, location.href);
    } catch (e) {
      return null;
    }
    if (abs.origin !== location.origin) return null;
    // Un enlace que solo cambia el hash o la query de ESTA página no navega.
    if (abs.pathname === location.pathname && abs.search === location.search) return null;

    /* LOS FILTROS DE LA COLECCIÓN NO NAVEGAN
       `ocu-collection.js` los atiende cambiando solo la rejilla, sin recargar.
       Esta cortina escucha en fase de CAPTURA sobre `document`, así que se
       adelantaba a ese manejador —que cuelga de la sección— y se llevaba el
       clic por delante: la página recargaba y el filtro parecía no ser ajax.

       Se excluyen TODAS, también las de categoría. Antes solo salían las que
       se quedaban en la misma ruta, porque cambiar de categoría recargaba de
       verdad; ahora `ocu-collection.js` cambia también el hero y el pie sin
       salir de la página, así que una cortina ahí taparía un cambio que dura
       lo que un fotograma.

       La condición es que ese script esté vivo: él pone `data-ocu-colajax` en
       el `<html>` al arrancar. Si no llegó a cargar, la marca no está, las
       pastillas vuelven a ser enlaces normales y la cortina las cubre como
       cualquier otra navegación. */
    if (a.closest('[data-filters]')) {
      if (document.documentElement.hasAttribute('data-ocu-colajax')) return null;
      if (abs.pathname === location.pathname) return null;
    }

    /* LOS PLANES ACEPTADOS ABREN UN DIÁLOGO
       `ocu-plans.js` los atiende sin salir de la página. Esta cortina escucha
       en captura y se los llevaba por delante, así que el enlace navegaba a la
       página en vez de abrir el diálogo — que funciona, pero no es lo que hace
       el sitio. Se excluyen por la dirección y no por una clase para que
       también valga si el enlace viene de un menú del admin, donde no se puede
       poner un atributo. */
    if (href.indexOf('medical-plans') > -1 || a.hasAttribute('data-plans')) return null;
    // El checkout y las cuentas se van del tema: que los lleve el navegador.
    if (/^\/(checkout|account)/.test(abs.pathname)) return null;

    /* EL ICONO DE LA BOLSA ABRE EL CAJÓN, NO LA PÁGINA
       Dawn le pone su propio oyente al enlace `#cart-icon-bubble` para abrir el
       cajón. Esta cortina escucha en captura, así que se adelantaba y navegaba
       a `/cart`: la bolsa se abría como página y no como cajón.

       La exclusión que tenía decía `cart/` CON barra, de modo que `/cart` a
       secas —que es justo el href del icono— se le escapaba. */
    if (a.id === 'cart-icon-bubble' || a.closest('#cart-icon-bubble')) return null;
    if (/^\/cart(\/|$)/.test(abs.pathname)) return null;
    return abs.href;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      var href = interno(a);
      if (!href) return;
      e.preventDefault();
      try {
        sessionStorage.setItem(BANDERA, '1');
      } catch (err) {}
      subir(function () {
        window.location.href = href;
      });
    },
    true
  );

  function destapar() {
    var vino = false;
    try {
      vino = sessionStorage.getItem(BANDERA) === '1';
      sessionStorage.removeItem(BANDERA);
    } catch (e) {}
    if (vino) {
      bajar();
    } else {
      /* Sin bandera no hay cortina que retirar, pero la tapa podría haber
         quedado puesta —una navegación cortada a medias, por ejemplo—, y
         entonces lo que se queda es la pantalla en marrón. */
      document.documentElement.removeAttribute('data-ocu-entrando');
    }
  }

  /* Al volver atrás el navegador restaura la página del caché, cortina
     incluida. Hay que retirarla a mano o se queda la pantalla en marrón. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.documentElement.removeAttribute('data-ocu-entrando');
    S('[data-ocu-curtain]').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  });

  /* ── Arranque ───────────────────────────────────────────────────────── */

  /* ── 3c. La barra se esconde al bajar y vuelve al subir ─────────────────

     No es "ocultar si y > X": es un ACUMULADOR de dirección. Se suma el
     desplazamiento mientras va en el mismo sentido y se pone a cero en cuanto
     cambia, así que hacen falta 26px seguidos hacia abajo para esconderla y
     34px seguidos hacia arriba para traerla. Ese umbral asimétrico es lo que
     hace que vuelva en cuanto insinúas subir, pero que no parpadee con el
     rebote del trackpad.

     Las excepciones, todas del sitio:
       - arriba de 110px no se esconde nunca, porque ahí la barra ES el hero;
       - con el mega menú, el cajón del carrito o el menú de móvil abiertos
         tampoco, o se iría con el panel colgando;
       - al final de la página vuelve, para que el pie quede alcanzable.

     Va en `transform`, no en `top`: así no toca la maquetación de nada. */

  var navUltimaY = null;
  var navAcc = 0;
  var navEscondida = false;

  function barraAuto(y) {
    if (!barra) return;

    if (navUltimaY === null) {
      navUltimaY = y;
      navAcc = 0;
      return;
    }

    var dy = y - navUltimaY;
    navUltimaY = y;
    /* Cambió el sentido: el acumulado anterior ya no cuenta. */
    if (navAcc * dy < 0) navAcc = 0;
    navAcc += dy;

    /* QUÉ CUENTA COMO «ALGO ABIERTO»
       Aquí decía `.menu-drawer-container details[open]`, que son los `details`
       de DENTRO del cajón, no el cajón. Y los de dentro están abiertos
       siempre: el tercer nivel del menú de móvil se fuerza abierto desde
       `header-drawer.liquid` porque un `details` cerrado se oculta con
       `content-visibility` y no se puede abrir solo con CSS.

       Resultado: `abierto` era verdadero en todas las páginas desde el primer
       pintado y la barra no se escondía nunca al bajar — se quedaba clavada
       arriba como una barra pegajosa cualquiera. El cajón es el `details` que
       lleva la clase, así que se pregunta por ÉL. */
    var abierto =
      !!document.querySelector('details.mega-menu[open]') ||
      !!document.querySelector(
        'cart-drawer.animate.active, .menu-drawer-container[open], .menu-drawer-container.menu-opening'
      ) ||
      document.body.classList.contains('overflow-hidden');

    var finDePagina =
      y + (window.innerHeight || 800) >
      (document.documentElement.scrollHeight || 0) - 40;

    var esconder = navEscondida;
    if (y < 110 || abierto) esconder = false;
    else if (navAcc > 26) esconder = true;
    else if (navAcc < -34 || finDePagina) esconder = false;

    /* La sombra solo con la página desplazada: en reposo se lee como un borde
       puesto a propósito, y el diseño no tiene ninguno ahí. */
    barra.classList.toggle('ocu-nav--scrolled', y > 10);

    if (esconder === navEscondida) return;
    navEscondida = esconder;
    barra.style.transform = esconder ? 'translateY(-112%)' : 'translateY(0)';
  }

  var tickScroll = 0;
  function alHacerScroll() {
    if (tickScroll) return;
    tickScroll = requestAnimationFrame(function () {
      tickScroll = 0;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      barraAuto(y);
      parallax();
      modoBarra();
      pasada();
    });
  }

  function iniciar() {
    if (barra) {
      barra.style.transition =
        (barra.style.transition ? barra.style.transition + ',' : '') +
        'transform .55s cubic-bezier(.22,.75,.2,1)';
      barra.style.transform = 'translateY(0)';
    }
    destapar();
    pasada();
    parallax();
    modoBarra();
    barraAuto(window.scrollY || document.documentElement.scrollTop || 0);
    arrancarKenBurns();
    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    // La red de seguridad: cada 1.6s repasa y repara lo que se quedó colgado.
    if (!repaso) repaso = setInterval(pasada, 1600);
  }

  /* Cuando algo mete elementos nuevos en la página —la rejilla de la colección
     al cambiar de filtro o al completar las páginas que faltan— hay que
     repartirles la aparición: no pasaron por el reparto inicial y se quedarían
     o invisibles o sin animar. Se escucha un aviso en vez de observar el DOM
     entero: un `MutationObserver` sobre el documento se dispara con cada
     cambio de estilo que hace esta misma capa. */
  window.addEventListener('ocu:dom', function () {
    pasada();
    parallax();
    modoBarra();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    pasada();
    /* El ken burns se salta si la pestaña arrancó en segundo plano —animar lo
       que nadie ve es tirar batería—. Al volver hay que arrancarlo, o la foto
       se queda quieta para siempre en esa visita. */
    arrancarKenBurns();
    if (!repaso) repaso = setInterval(pasada, 1600);
  });

  /* El editor de temas monta y desmonta secciones sin recargar, así que lo
     que entra nuevo hay que volver a mirarlo. */
  document.addEventListener('shopify:section:load', function () {
    pasada();
    parallax();
    arrancarKenBurns();
  });

  if (document.body) iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar, { once: true });
})();
